var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.style }, [
    _c("div", { staticClass: "topBox" }, [
      _c("img", {
        staticStyle: { width: "100%" },
        attrs: { src: _vm.activityBackgroundImage, alt: "" }
      }),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.titleText))]),
      _vm._v(" "),
      _c("div", { staticClass: "gradients" })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "contentDiv" }, [
      _c(
        "ul",
        _vm._l(_vm.msgfromfa, function(tab, index) {
          return _c("li", { key: index }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: tab.content != "提醒文案",
                    expression: "tab.content != '提醒文案'"
                  }
                ],
                staticClass: "left"
              },
              [
                tab.require == 1 ? _c("span", [_vm._v("*")]) : _vm._e(),
                _vm._v(_vm._s(tab.content) + ":\n          ")
              ]
            ),
            _vm._v(" "),
            tab.type == "text"
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          tab.content != "提醒文案" && tab.content != "备注",
                        expression:
                          "tab.content != '提醒文案' && tab.content != '备注'"
                      }
                    ],
                    staticClass: "right"
                  },
                  [_c("el-input", { attrs: { type: tab.type, readonly: "" } })],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: tab.content == "备注",
                    expression: "tab.content == '备注'"
                  }
                ],
                staticClass: "right"
              },
              [_c("textarea")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: tab.content == "提醒文案",
                    expression: "tab.content == '提醒文案'"
                  }
                ]
              },
              [
                _c("span", { staticStyle: { color: "#999" } }, [
                  _vm._v(_vm._s(tab.content))
                ])
              ]
            ),
            _vm._v(" "),
            tab.type == "radio"
              ? _c(
                  "div",
                  { staticClass: "right" },
                  [
                    _c(
                      "el-radio-group",
                      {
                        attrs: { readonly: "" },
                        model: {
                          value: _vm.radio1,
                          callback: function($$v) {
                            _vm.radio1 = $$v
                          },
                          expression: "radio1"
                        }
                      },
                      [
                        _c("el-radio", { attrs: { label: 0 } }, [_vm._v("男")]),
                        _vm._v(" "),
                        _c("el-radio", { attrs: { label: 1 } }, [_vm._v("女")])
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        })
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "btn-sign" }, [_vm._v("确认报名")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }